'use es6';

import SeamlessImmutable from 'seamless-immutable';
import { FINDER_FUNCTIONS_CREATE, FINDER_FUNCTIONS_CREATE_ENDPOINT, FINDER_FUNCTIONS_DEPLOY_ERROR, FINDER_FUNCTIONS_DEPLOY_REQUEST, FINDER_FUNCTIONS_DEPLOY_RECEIVE, FINDER_FUNCTIONS_CLEAR_DEPLOY_LOGS } from 'DesignData/actions/ActionTypes';
export default function Functions(state = SeamlessImmutable({
  functionCreationInProgress: false,
  functionDeploymentInProgress: false,
  functionDeploymentLogs: ''
}), action) {
  switch (action.type) {
    case FINDER_FUNCTIONS_CREATE:
    case FINDER_FUNCTIONS_CREATE_ENDPOINT:
      {
        if (action.serverlessJson || action.error || action.validationErrors) {
          return Object.assign({}, state, {
            functionCreationInProgress: false
          });
        } else {
          return Object.assign({}, state, {
            functionCreationInProgress: true
          });
        }
      }

    case FINDER_FUNCTIONS_DEPLOY_REQUEST:
      {
        return Object.assign({}, state, {
          functionDeploymentInProgress: true
        });
      }

    case FINDER_FUNCTIONS_DEPLOY_RECEIVE:
      {
        return Object.assign({}, state, {
          functionDeploymentInProgress: false,
          functionDeploymentLogs: action.deployLogs
        });
      }

    case FINDER_FUNCTIONS_DEPLOY_ERROR:
      {
        return Object.assign({}, state, {
          functionDeploymentInProgress: false
        });
      }

    case FINDER_FUNCTIONS_CLEAR_DEPLOY_LOGS:
      {
        return Object.assign({}, state, {
          functionDeploymentLogs: ''
        });
      }

    default:
      return state;
  }
}